import {
  ContinousEvaluationParams,
  VleresimeGjyqParams,
  VleresimeParams,
} from '../../../../interfaces/vleresime.interface';

export const getVleresimeApiUrl = (
  { page, size, id, emri, mbiemri, klasaId }: VleresimeParams,
  url = 'lendes',
) => {
  let queryString = `/klasa-student/sipas-${url}/${id}/te-pavleresuar?size=${size}&page=${page}&sort=emriStudenti:asc`;

  if (emri) {
    queryString += `&filter=emriStudenti:ilike:${emri}`;
  }
  if (mbiemri) {
    queryString += `&filter=emriStudenti:ilike:${mbiemri}`;
  }
  if (klasaId && klasaId > 0) {
    queryString += `&filter=klasaId:eq:${klasaId}`;
  }

  return queryString;
};

export const getContinousEvaluationUrl = (
  {
    klasaId,
    page,
    size,
    emri,
    id,
    vitiAkademikId,
    studentiId,
  }: ContinousEvaluationParams,
  url = 'vazhdues-sipas-lendes/per-pedagog',
) => {
  let queryString = `/vleresime-student/${id}/${url}?size=${size}&page=${page}&sort=emriStudenti:asc`;

  if (emri) {
    queryString += `&filter=emriStudenti:ilike:${emri}`;
  }

  if (klasaId && klasaId > 0) {
    queryString += `&filter=klasaId:eq:${klasaId}`;
  }
  if (vitiAkademikId && vitiAkademikId > 0) {
    queryString += `&filter=vitiAkademikId:eq:${vitiAkademikId}`;
  }
  if (studentiId && studentiId > 0) {
    queryString += `&filter=klasaStudentId:eq:${studentiId}`;
  }

  return queryString;
};

export const getVleresimeGjyqApiUrl = (
  {
    page,
    size,
    klasaId,
    vitiAkademikId,
    klasaStudentId,
    lendeGjyqId,
  }: VleresimeGjyqParams,
  url = '',
  sort = '&sort=emriStudenti:asc',
) => {
  let queryString = `/vleresime-gjyq${url}?size=${size}&page=${page}${sort}&filter=vitiAkademikId:eq:${vitiAkademikId}`;

  if (klasaId && klasaId > 0) {
    queryString += `&filter=klasaId:eq:${klasaId}`;
  }
  if (klasaStudentId && klasaStudentId > 0) {
    queryString += `&filter=klasaStudentId:eq:${klasaStudentId}`;
  }
  if (lendeGjyqId && lendeGjyqId > 0) {
    queryString += `&filter=lendeGjyqId:eq:${lendeGjyqId}`;
  }

  return queryString;
};
